export interface TeamsConfig {
	stargateRoot: string;
}

export const DEFAULT_CONFIG: TeamsConfig = {
	stargateRoot: '/gateway/api',
};
